import { render, staticRenderFns } from "./ApprovalDialog.vue?vue&type=template&id=0b84d798&scoped=true"
import script from "./ApprovalDialog.vue?vue&type=script&lang=js"
export * from "./ApprovalDialog.vue?vue&type=script&lang=js"
import style0 from "./ApprovalDialog.vue?vue&type=style&index=0&id=0b84d798&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b84d798",
  null
  
)

export default component.exports